/* eslint-disable react/prop-types */
// React
import React from 'react';
// PropType
import PropTypes from 'prop-types';
// MUI
import { Typography, Grid } from '@material-ui/core';
// styles
import withStyles from '@material-ui/core/styles/withStyles';
import isEmpty from 'lodash/isEmpty';
import Divider from '@material-ui/core/Divider';
import { formatCurrencyWithoutCurrency, keyEmptyCheck } from 'aurora-utils/utils';
import styles from './styles';
import ADGMPanel from '../ADGMPanel';

function formatData(key, data) {
  if (key === 'percentage') {
    return data[key] ? `${data[key]}%` : '-';
  }
  if (key?.toLowerCase() === 'amount') {
    return keyEmptyCheck('AED_amount', {
      num: formatCurrencyWithoutCurrency(data[key]),
    });
  }

  return data[key] ?? '-';
}

function calculateColumns(coloumns, index) {
  const ColMap = {
    0: 5,
    1: 3,
  };

  const EqualGaps = coloumns?.length > 3;

  return index === coloumns.length - 1 ? 2 : EqualGaps ? 3 : ColMap[index] || 3;
}

function Body({ classes, coloumns, data }) {
  return (
    !isEmpty(coloumns) &&
    !isEmpty(data) && (
      <Grid
        container
        direction='row'
        justifyContent='space-between'
        alignItems='center'
        spacing={4}
        className={classes.container}
      >
        {coloumns?.map((label, index) => (
          <Grid item sm={calculateColumns(coloumns, index)} key={label}>
            <Typography variant='body1' className={classes.headerText}>
              {label}
            </Typography>
          </Grid>
        ))}
        <Divider className={classes.divider} />
        {data?.map(row => (
          <>
            <ADGMTableRow classes={classes} data={row} />
            <Divider className={classes.divider} />
          </>
        ))}
      </Grid>
    )
  );
}

const ADGMTableRow = ({ data, classes }) => {
  return (
    !isEmpty(data) &&
    Object.keys(data).map((key, index, dataArr) => (
      <Grid item sm={index === dataArr.length - 1 ? 2 : 3} key={data[key]}>
        <Typography variant='body1' className={classes.label}>
          {formatData(key, data)}
        </Typography>
      </Grid>
    ))
  );
};

const ADGMPanelTable = ({ classes, data, coloumns, Title, isAccordion }) => {
  return (
    data?.length > 0 && (
      <ADGMPanel
        {...{
          classes,
          isAccordion,
          title: Title,
        }}
      >
        <Body data={data} coloumns={coloumns} classes={classes} />
      </ADGMPanel>
    )
  );
};

ADGMPanelTable.propTypes = {
  classes: PropTypes.object.isRequired,
  coloumns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  Title: PropTypes.string.isRequired,
  isAccordion: PropTypes.bool.isRequired,
};

export default withStyles(styles)(ADGMPanelTable);
